import { themeColor } from "./_helpers";

export const formTokens = {
  bg: themeColor({
    base: "{colors.neutral.50}",
    _themeBlack: "{colors.whiteAlpha.100}",
    _themeWhite: "{colors.neutral.50}",
  }),
  bgHover: themeColor({
    base: "{colors.neutral.100}",
    _themeBlack: "{colors.whiteAlpha.200}",
    _themeWhite: "{colors.neutral.100}",
  }),
  bgSolid: themeColor({
    base: "{colors.white}",
    _themeBlack: "{colors.dark.800}",
    _themeWhite: "{colors.white}",
  }),
  border: themeColor({
    base: "{colors.neutral.200}",
    _themeBlack: "{colors.whiteAlpha.300}",
    _themeWhite: "{colors.neutral.200}",
  }),
  borderFocus: themeColor({
    base: "{colors.primary.500}",
    _themeBlack: "{colors.primary.400}",
    _themeWhite: "{colors.primary.500}",
  }),
  borderError: themeColor({
    base: "{colors.red.500}",
    _themeBlack: "{colors.red.400}",
    _themeWhite: "{colors.red.500}",
  }),
  bgError: themeColor({
    base: "{colors.red.50}",
    _themeBlack: "{colors.red.900}",
    _themeWhite: "{colors.red.50}",
  }),
  placeholder: themeColor({
    base: "{colors.neutral.400}",
    _themeBlack: "{colors.neutral.500}",
    _themeWhite: "{colors.neutral.400}",
  }),
  label: themeColor({
    base: "{colors.neutral.600}",
    _themeBlack: "{colors.neutral.300}",
    _themeWhite: "{colors.neutral.600}",
  }),
  labelActive: themeColor({
    base: "{colors.primary.700}",
    _themeBlack: "{colors.primary.300}",
    _themeWhite: "{colors.primary.700}",
  }),
  required: themeColor({
    base: "{colors.red.500}",
    _themeBlack: "{colors.red.400}",
    _themeWhite: "{colors.red.500}",
  }),
  menuBg: themeColor({
    base: "{colors.white}",
    _themeBlack: "{colors.dark.800}",
    _themeWhite: "{colors.white}",
  }),
  menuBorder: themeColor({
    base: "{colors.neutral.200}",
    _themeBlack: "{colors.whiteAlpha.300}",
    _themeWhite: "{colors.neutral.200}",
  }),
  fg: themeColor({
    base: "{colors.neutral.700}",
    _themeBlack: "{colors.neutral.200}",
    _themeWhite: "{colors.neutral.700}",
  }),
  brand: themeColor({
    base: "{colors.primary.50}",
    _themeBlack: "{colors.blackAlpha.600}",
    _themeWhite: "{colors.primary.50}",
  }),
};
